import { render, staticRenderFns } from "./ConfigureDocumentField.vue?vue&type=template&id=5cf2f74c&scoped=true"
import script from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocumentField.vue?vue&type=style&index=0&id=5cf2f74c&prod&scoped=true&lang=css"
import style1 from "./ConfigureDocumentField.vue?vue&type=style&index=1&id=5cf2f74c&prod&scoped=true&lang=css"
import style2 from "./ConfigureDocumentField.vue?vue&type=style&index=2&id=5cf2f74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2f74c",
  null
  
)

export default component.exports